import { useEffect, useMemo, useState } from 'react';

export const useDebounce = <T>(fn: () => T, dependencies: any[], delay: number = 500): T => {
  const defaultValue: T = useMemo(() => {
    return fn();
  }, [fn]);
  // State and setters for debounced value
  const [debouncedValue, setDebouncedValue] = useState<T>(defaultValue);
  useEffect(
    () => {
      // Update debounced value after delay
      const handler = setTimeout(() => {
        setDebouncedValue(fn());
      }, delay);

      return () => {
        clearTimeout(handler);
      };
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [...dependencies, delay, fn], // Only re-call effect if value or delay changes
  );
  return debouncedValue;
};
